import Button from '@atlaskit/button';
import MoreIcon from '@atlaskit/icon/glyph/more';
import DropdownMenu from '@atlaskit/dropdown-menu';
import { jsx } from '@emotion/react';
import React from 'react';

const MoreDropdownMenu: React.FC = (props) => <DropdownMenu
  placement="bottom-end"
  trigger={({ triggerRef, ...props }) => (
    <Button
      {...props}
      iconBefore={<MoreIcon label="more" />}
      appearance="subtle"
      ref={triggerRef}
    />)}
  // trigger= {<Button appearance="subtle" iconAfter={<MoreIcon label=""/>}/>}
  // triggerType="default"
  {...props}
/>;

export default React.memo(MoreDropdownMenu) as typeof MoreDropdownMenu;
